var BaseViews = require('./base');
var CartLocationDisplay = require('./cart/cart-location-display');
require('./delivery-postal-code-form/delivery-postal-code-form.scss');
var DeliveryPostalCodeFormInput = require('./delivery-postal-code-form/delivery-postal-code-input');


var DeliveryPostalCodeFormSuccessState = BaseViews.LayoutView.extend({
  className: 'fmcy-delivery-postal-code-form-success-state',
  template: require('./delivery-postal-code-form/delivery-postal-code-form-success-state.html'),
  initialize: function(options) {
      var self = this;
      this.options = _.defaults(
          options || {},
          {
              postalCode: 'V0N 2M2'
          }
      );
  },
  serializeData: function () {
    return {
      postalCode: this.options.postalCode
    }
  }
});

var DeliveryPostalCodeForm = BaseViews.LayoutView.extend({
    className: 'fmcy-delivery-postal-code-form',
    template: require('./delivery-postal-code-form/delivery-postal-code-form.html'),
    initialize: function(options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                _appChannel: null,
                error: false,
                errorMessage: 'Please verify postal code.',
                changeToLocationModel: null,
                model: null,
                referrer: 'entry'
            }
        );
        if (this.options.model) {
          this.deliveryModel = this.options.model;
        } else {
          this.deliveryModel = this.options._appChannel.request('cart:get:delivery:model');
        }  
    },
    regions: {
      postalCodeFormRegion: '.fmcy-postal-code-form-region',
      deliverySuccessStateRegion: '.fmcy-delivery-success-state-region'
    },
    _hideSuccessMessage: function () {
      this.deliverySuccessStateRegion.empty();
    },
    _renderSuccessMessage: function (postalCode) {
      var deliveryPostalCodeFormSuccessState = new DeliveryPostalCodeFormSuccessState({
        postalCode: postalCode
      });
      this.deliverySuccessStateRegion.show(deliveryPostalCodeFormSuccessState);
      this.trigger('show:continue:button');
    },
    _renderDeliveryPostalCodeFormInput: function (_options) {
      var self = this;
      var options = _.defaults(
          _options || {},
          {
              deliveryMethod: 'local_delivery',
              error: self.options.error,
              changeToLocationModel: self.options.changeToLocationModel,
              errorMessage: self.options.errorMessage
          }
      );

      this.deliveryPostalCodeFormInput = new DeliveryPostalCodeFormInput({
        _appChannel: this.options._appChannel,
        model: this.deliveryModel.get('cartDeliveryAddressModel'),
        error: options.error,
        changeToLocationModel: options.changeToLocationModel,
        errorMessage: options.errorMessage,
        source: 'embedded'
      });

      this.deliveryPostalCodeFormInput.on('toggle:validation:alert', function (show) {
        if (show == true) {
          self._hideSuccessMessage();
        }
      });

      this.deliveryPostalCodeFormInput.on('validate:postal:code', function (postalCode) {
        self.options._appChannel.request('validate:postal:code:delivery:area', postalCode).then(function (result) {
            if (result.error == true) {
              self.deliveryPostalCodeFormInput.setAlertMessage('Sorry we cannot deliver to that postal code.');
              self.deliveryPostalCodeFormInput.toggleValidationAlert(true);
              self.trigger('hide:continue:button');
              self._hideSuccessMessage();
              if (self.deliveryPostalCodeFormInput) {
                self.deliveryPostalCodeFormInput.resetVerifyButton();
              }
            } else {
              if (self.deliveryPostalCodeFormInput) {
                self.deliveryPostalCodeFormInput.resetVerifyButton();
              }
              // display success state...
              self._renderSuccessMessage(postalCode);
              if (result.response && result.response.withinDeliveryAreaSlug) {
                self.options._appChannel.trigger('location:selected', result.response.withinDeliveryAreaSlug, self.options.referrer);
              }
              
            }
        });
      }); // end on validate:postal:code

      this.postalCodeFormRegion.show(this.deliveryPostalCodeFormInput);
    },
    _maybeRenderDeliveryPostalCodeFormSuccessState() {
      var currentSelectedLocationSlug = this.options._appChannel.request('get:filter:location:details').get('slug');

      if (currentSelectedLocationSlug == this.deliveryModel.get('cartDeliveryAddressModel').get('local_delivery_confirmed_farm_location_slug') &&
      this.deliveryModel.get('cartDeliveryAddressModel').get('local_delivery_postal_code_verified') != null &&
      this.deliveryModel.get('cartDeliveryAddressModel').get('local_delivery_postal_code_verified') == this.deliveryModel.get('cartDeliveryAddressModel').get('local_delivery_postal_code')) {
        this._renderSuccessMessage(this.deliveryModel.get('cartDeliveryAddressModel').get('local_delivery_postal_code'));
      }
    },
    onRender: function() {
      var self = this;

      this._renderDeliveryPostalCodeFormInput();
      this._maybeRenderDeliveryPostalCodeFormSuccessState();

      BaseViews.LayoutView.prototype.onRender.call(self);
    }
});

module.exports = DeliveryPostalCodeForm;



/** WEBPACK FOOTER **
 ** ./assets/js/common/delivery-postal-code-form.js
 **/